<template>
    <div class="wrap">
        <div class="font-6">
            <IconBase width="20" height="20"
                      iconName="levelPlayIcon" class="bidderIcon"/>
            Bidding
            <Tooltip :text="biddingTooltipText"/>
        </div>
        <div class="font-7">Instance Id: {{ getInstanceId }}</div>
        <switcher uniqueId="bidderStatus"
                  :isActive="isActive"
                  :text="switcherActiveText"
                  textInactive="Inactive"
                  :styles="switcherStyle"
                  :isDisabled="viewOnly || activeDisabled"
                  class="switcher"
                  @changed="activeChanged"
        />
        <div class="noGroups" v-if="showNoGroupsAlert">
            <Tooltip text="No Groups assign for this instance">
                <IconBase width="12" height="11" :iconColor="consts.COLORS.NEUTRAL_700"
                          iconName="warningIcon"/>
            </Tooltip>
        </div>
    </div>
</template>

<script>
import consts from 'services/metaData/consts';
import IconBase from 'components/IconBase.vue';
import Switcher from 'components/Switcher.vue';
import Tooltip from 'components/Tooltip/Tooltip.vue';
import authService from 'services/auth';

const adUnitToVersion = {
    rewardedVideo: '6.10.0',
    interstitial: '6.9.0',
    banner: '7.1.4.1'
};

export default {
    name: 'Bidder',
    components: {
        IconBase, Switcher, Tooltip
    },
    props: {
        instanceId: {
            type: Number,
            default: null
        },
        isActive: {
            type: Boolean,
            default: false
        },
        isTest: {
            type: Boolean,
            default: false
        },
        showNoGroupsAlert: {
            type: Boolean,
            default: false
        },
        activeDisabled: {
            type: Boolean,
            default: false
        },
        adUnit: String
    },
    data: () => ({
        viewOnly: true,
        consts
    }),
    async beforeCreate() {
        this.viewOnly = await authService.isAuthorized(['viewer']);
    },
    computed: {
        switcherStyle() {
            return this.isTest ? { color: 'orange', size: 'small' } : { size: 'small' };
        },
        switcherActiveText() {
            return this.isTest ? 'Active (Test)' : 'Active';
        },
        getInstanceId() {
            return this.instanceId || 'Not Defined';
        },
        biddingTooltipText() {
            // eslint-disable-next-line max-len
            return `ironSource network bidding support for ${this.consts.ADUNIT_TO_NAME[this.adUnit]} is available starting SDK version ${adUnitToVersion[this.adUnit]}`;
        }
    },
    methods: {
        activeChanged() {
            this.$emit('activeChanged', !this.isActive);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";

    .wrap {
        background-color: $light-200;
        display: grid;
        justify-content: stretch;
        grid-template-columns: 120px 170px 72px 15px;
        grid-template-rows: 48px;
        margin: 0 15px 15px 15px;
        line-height: 48px;
        padding-left: 15px;
    }
    .bidderIcon{
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        line-height: 17px;
    }
    .switcher{
        margin-top: -2px;
    }
    .noGroups{
        line-height: 46px;
    }
</style>
